export default __webpack_public_path__ + "static/media/logo-company.0afbfbbd.webp";